export enum StatusFilter {
	ANY = 'ANY',
	ONLINE = 'ONLINE',
	OFFLINE = 'OFFLINE',
	NOT_INSTALLED = 'NOT_INSTALLED',
}
